import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { AuthTokenService } from '../../../../ppb/shared/services/auth-token.service';
import { UserService } from '../../../../ppb/shared/services/user.service';
import { HTTP_STATUS_CODE } from '../../../models/http-status-code.model';
import { SduExtRefreshResponse } from '../../../models/sduext/sduext-refresh-repsonse-model';

@Injectable({
  providedIn: 'root'
})
export class HttpRefreshTokenInterceptorService implements HttpInterceptor {

  constructor(
    private userService: UserService,
    private authTokenService: AuthTokenService,
    private router: Router
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(catchError((err: HttpErrorResponse) => {
        if ((err.status === HTTP_STATUS_CODE.UNAUTHORIZED
          || err.status === HTTP_STATUS_CODE.FORBIDDEN)
          && this.authTokenService.getRefreshToken()) {
          return this.userService.refreshToken().pipe(
            concatMap((response:SduExtRefreshResponse) => {
              return next.handle(req.clone({
                headers: req.headers.set('Authorization', `Bearer ${response.access_token}`)
              }));
            }),
            catchError(retryErr => {
              this.userService.logOut().subscribe(() => {
                this.router.navigateByUrl('/login');
              });
              return throwError(retryErr);
            }),
          );
        } else {
          return throwError(err);
        }
      }));
  }
}
